<script>

    import { toast } from 'bulma-toast'
    import { replace } from 'svelte-spa-router'

    import { configStore, modalStore } from '../stores'

    import StorageService from '../$services/storage.service'
    import ConfigsService from '../$services/configs.service'
    import LocationsService from '../$services/locations.service'

    import Menu from '../$layouts/menu.layout.svelte'
    import Container from '../$layouts/container.layout.svelte'
    import Tabs from '../$components/tabs.svelte'
    import Theme from '../$components/theme.svelte'

    import UserComponent from '../users/component.user.svelte'
    import UserUpdateModal from '../users/modal.update.svelte'
    import UserUpdateEmailComponent from '../users/component.update.email.svelte'
    import UserUpdatePasswordComponent from '../users/component.update.password.svelte'

    import LocationsComponent from '../locations/component.locations.svelte'
    import LocationCreateModal from '../locations/modal.create.svelte'
    import LocationModal from '../locations/modal.location.svelte'
    import LocationUpdateModal from '../locations/modal.update.svelte'
    import LocationUploadModal from '../locations/modal.upload.svelte'

    import PackagesComponent from '../packages/component.packages.svelte'
    import PackageCreateModal from '../packages/modal.create.svelte'
    import PackageModal from '../packages/modal.package.svelte'
    import PackageUpdateModal from '../packages/modal.update.svelte'

    import ConfigEmailComponent from './component.config.email.svelte'
    import PreviewEmailModal from './modal.preview.email.svelte'

    import ConfigTrackingComponent from './component.config.tracking.svelte'
    import ConfigLinkComponent from './component.config.link.svelte'

    import IntegrationsView from '../integrations/view.integrations.svelte'

    import Merchandises from '../merchandises/component.merchandises.svelte'
    import MerchandiseModal from '../merchandises/modal.merchandise.svelte'
    import MerchandiseCreateModal from '../merchandises/modal.create.svelte'
    import MerchandiseUpdateModal from '../merchandises/modal.update.svelte'

    export let params = {}

    getConfig()

    async function getConfig() {

        const resp = await ConfigsService.getConfig()

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        if(!resp.data.email)
            resp.data.email = {}

        if(!resp.data.tracking)
            resp.data.tracking = {}

        configStore.set(resp.data)
    }

    let selected = 'user'

    if(params.tab)
        selected = params.tab

    const tabsOptions = [
        {key: 'user', name: 'Usuario', icon: 'user'},
        {key: 'locations', name: 'Direcciones', icon: 'address-book'},
        {key: 'packages', name: 'Paquetes', icon: 'box-open'},
        {key: 'merchandises', name: 'Mercancias', icon: 'shopping-cart'},
        {key: 'integrations', name: 'Integraciones', icon: 'shopping-bag'},
        {key: 'emails', name: 'Correo', icon: 'envelope'},
        {key: 'trackings', name: 'Rastreo', icon: 'map-marker-alt'},
        {key: 'links', name: 'SmartLink', icon: 'link'},
    ]

</script>

<Menu />

<UserUpdateModal />
<PreviewEmailModal />

<MerchandiseModal />
<MerchandiseCreateModal />
<MerchandiseUpdateModal />

<Container>

    <Tabs bind:selected options={tabsOptions} />

    {#if selected === 'user'}

        <UserComponent />

        <div class="is-divider"></div>

        <div class="columns">
            <div class="column">
                <UserUpdateEmailComponent />
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column">
                <UserUpdatePasswordComponent />
            </div>
            <div class="is-divider-vertical"></div>
            <div class="column">
                <div style="height: 100%;">
                    <div class="title">Cambiar tema</div>
                    <div class="space-top">
                        <Theme />
                    </div>
                </div>
            </div>
        </div>
    {:else if selected === 'locations'}

        <LocationCreateModal />
        <LocationModal />
        <LocationUpdateModal />
        <LocationUploadModal />

        <LocationsComponent />

    {:else if selected === 'packages'}

        <PackageCreateModal />
        <PackageModal />
        <PackageUpdateModal />

        <div class="items-end">
            <button on:click={() => modalStore.set('package_create_modal')} class="button">
                <span class="icon"><i class="fas fa-plus"></i></span>
                <span>Crear paquete</span>
            </button>
            <br>
        </div>

        <PackagesComponent />

    {:else if selected === 'integrations'}

        <IntegrationsView />

    {:else if selected === 'emails'}

        <ConfigEmailComponent />

    {:else if selected === 'trackings'}

        <ConfigTrackingComponent />

    {:else if selected === 'links'}

        <ConfigLinkComponent />

    {:else if selected === 'merchandises'}

        <Merchandises />

    {/if}

</Container>